const s = {
    markInnerScroll: function ({target}) {
        // if (stepCheckpoint !== 0 && Math.abs(target.scrollLeft - stepCheckpoint) < step) {
        //     return
        // }
        // console.log(target.scrollLeft)
        // stepCheckpoint = target.scrollLeft
        //
        // /* @TODO cover edge cases */

        if (target.scrollLeft !== target.scrollWidth - target.clientWidth) {
            target.classList.add('js--has-scroll-right');
        } else {
            target.classList.remove('js--has-scroll-right');
        }

        if (target.scrollLeft > 0) {
            target.classList.add('js--has-scroll-left');
        } else {
            target.classList.remove('js--has-scroll-left');
        }

        if (target.scrollTop !== target.scrollHeight - target.clientHeight) {
            target.classList.add('js--has-scroll-bottom');
        } else {
            target.classList.remove('js--has-scroll-bottom');
        }

        if (target.scrollTop > 0) {
            target.classList.add('js--has-scroll-top');
        } else {
            target.classList.remove('js--has-scroll-top');
        }
    },

    initFor: function (target) {
        s.markInnerScroll({target});
        target.addEventListener('scroll', s.markInnerScroll);
        let timerId;

        const throttleMarking = () => {
            if (timerId) {
                return;
            }
            timerId = setTimeout(() => {
                s.markInnerScroll({target});
                timerId = null;
            }, 150);
        };

        window.addEventListener('scroll', throttleMarking);
        window.addEventListener('resize', throttleMarking);
    },

    init() {
        /* @TODO support progressive enhancement */

        const selector = '.js--indicate-inner-scroll';
        const targets = document.querySelectorAll(selector);

        if (!targets.length) {
            return;
        }

        targets.forEach(s.initFor);
    },
};

const scrollIndicatorModule = s;

module.exports = scrollIndicatorModule;
